import React from 'react';
import { View, Text, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { AlertCircle } from 'lucide-react-native';
import { useTheme, SPACING, TYPOGRAPHY, BORDER_RADIUS } from '../../theme';

interface ErrorBannerProps {
  /** Renders nothing when null/empty — call sites can drop their `{error && …}` guard. */
  message: string | null | undefined;
  style?: StyleProp<ViewStyle>;
  testID?: string;
}

/**
 * The compact inline error banner used under form fields and submit
 * buttons. For full-screen failures with a retry action use ErrorState.
 */
export function ErrorBanner({ message, style, testID }: ErrorBannerProps) {
  const { colors } = useTheme();
  if (!message) return null;
  return (
    <View style={[styles.container, { backgroundColor: colors.dangerSoft }, style]} testID={testID}>
      <AlertCircle size={16} color={colors.danger} style={styles.icon} />
      <Text
        style={[styles.text, { color: colors.danger }]}
        accessibilityLiveRegion="polite"
        accessibilityRole="alert">
        {message}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: SPACING.sm,
    borderRadius: BORDER_RADIUS.md,
    paddingVertical: SPACING.sm,
    paddingHorizontal: SPACING.md,
  },
  icon: {
    marginTop: 2,
  },
  text: {
    ...TYPOGRAPHY.bodySmall,
    flex: 1,
  },
});
